<template>
  <forms-input
    data-lpignore="true"
    :autofocus="autofocus"
    class="forms-search"
    clearable
    icon-pre="search"
    :placeholder="placeholder"
    :size="size"
    @input="(value) => $emit('search', value)"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    v-bind="$attrs"
    v-model="iValue">
    <slot></slot>
  </forms-input>
</template>

<script>
export default {
  name: 'FormsSearch',

  model: {
    event: 'input',
    prop: 'value'
  },

  data(){
    return {
      iValue: null
    }
  },

  watch:{
    value: {
      handler(val){
        this.iValue = val
      },
      immediate: true
    }
  },

  props: {
    autofocus: {
      type: Boolean,
      default: true
    },

    placeholder: {
      type: String,
      default: 'Start typing to filter out the values'
    },

    size: {
      type: String,
      default: 's',
      validator: (value) => ['s', 'm', 'l' ].includes(value)
    },

    value: {
      type: String,
    }
  }
}
</script>
